import React from 'react'
import { observer } from 'mobx-react'
import { store } from '../../stores/store'



let TopRightUI = () => {

  return (
    <div className="top-right-ui">
      <div className="remaining-changes">
        <span className="remaining-changes-label" dangerouslySetInnerHTML={{__html: store.t("remaining_changes")}} />
        <span className="remaining-changes-value">{store.remainingAepChanges}</span>
      </div>
    </div>
  )
}


export default observer(TopRightUI)
